module.exports = __webpack_public_path__ + "static/media/CompletedGray.5d5edecd.svg";